var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"chart dark:bg-slate-800",attrs:{"option":_vm.option,"autoresize":"","theme":_vm.theme,"id":"charts-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }